import React from 'react';
import { typeOf, colourHex } from '../../utils/sessionTypes';

// A session's type as a small label in the club's colour for it, as on the
// timetable
export default function SessionTypePill({ session, style }) {
  const t = typeOf(session);
  if (!t) return null;
  return (
    <span style={{
      fontSize: 'var(--text-pill)', fontWeight: 700, color: 'var(--booking-text-on-dark)',
      background: colourHex(t.colour), borderRadius: 999,
      padding: '0 0.4rem', marginLeft: '0.4rem', lineHeight: 1.6,
      ...style,
    }}>
      {t.name}
    </span>
  );
}
